import Select from "./Select";
import Range from "./Range";

export default class Form {
	constructor(el) {
		this.element		= el;
		this.toggleMobile 	= this.element.querySelector('[togglemobile]');
		this.resetFilters 	= this.element.querySelectorAll('[data-resetfilters]');
		this.searchToggle 	= this.element.querySelectorAll('[searchtoggle]');

		this.select = new Select(this.element);
		this.range 	= new Range(this.element);

		this.toggleMobile.addEventListener('click', (event) => {
			this.toggleMobile.closest('[data-component="forms"]').toggleAttribute('fieldwrappervisible');
		});

		this.searchToggle.forEach((searchToggle) => {
			searchToggle.addEventListener('click', (event) => {
				event.target.classList.toggle('search-field--open');
				const searchField = searchToggle.parentNode.querySelector('[searchfield]');
				searchField.classList.toggle('search-field--open');
				
				// Focus the input field when opened
				if (searchField.classList.contains('search-field--open')) {
					searchField.querySelector('input').focus();
				}
			});
		});

		// Total reset of custom form fields
		document.body.addEventListener('click', (event) => {
			if(event.target.closest('[mobilereset]')) {
				event.target.closest('[mobilereset]').style.display = 'none';
			}
			if(event.target.closest('[data-resetfilters]')) {
				// Reset all standard fields
				event.target.closest('.ajax-load-more').querySelector('form').reset();

				// Reset all custom Select fields
				this.element.querySelectorAll('[selectgroup]').forEach((selectGroup) => {
					this.select.resetField(selectGroup, selectGroup.querySelectorAll('[optionvalue]'));
				})

				// Reset all custom Range fields
				this.element.querySelectorAll('[rangegroup]').forEach((rangeGroup) => {
					this.range.resetField(rangeGroup);
				})

				let ajaxParent = this.element.closest('.ajax-load-more');
				if(ajaxParent.hasAttribute('splitloadposts')) {
					let filters 			= ajaxParent.querySelector('.filter-form');
					let articlesInitial		= document.querySelector('[articlesinitial]');
					let articlesAdditional 	= document.querySelector('[articlesadditional]');
					let hideOnFilter 		= document.querySelectorAll('[hideonfilter]');
					window.app.loadPosts.loadPostsSplit('filter-change', filters, articlesInitial, articlesAdditional, hideOnFilter);
				} else {
					let loadMoreFilters 			= ajaxParent.querySelector('.filter-form');
					let loadMoreButton 				= ajaxParent.querySelector('.btn--load-more');
					let loadMoreButtonWrapper 		= ajaxParent.querySelector('.load-more-button');
					let loadMoreContainer			= ajaxParent.querySelector('.load-more-container');
					let paginationContainer			= ajaxParent.querySelector('.pagination-container');

					window.app.loadPosts.loadPosts('filter-change', ajaxParent, loadMoreButton, loadMoreFilters, loadMoreContainer, paginationContainer, loadMoreButtonWrapper);
				}
			}
		})

		// Trigger custom search field on input
		let searchTimer;
		this.searchFields = document.querySelectorAll('[searchfield] input');

		this.searchFields.forEach((searchField) => {
			searchField.addEventListener('keyup', (e) => {
				let ajaxParent = searchField.closest('.ajax-load-more');

				if(ajaxParent.hasAttribute('splitloadposts')) {
					let filters 			= ajaxParent.querySelector('.filter-form');
					let articlesInitial		= document.querySelector('[articlesinitial]');
					let articlesAdditional 	= document.querySelector('[articlesadditional]');
					let hideOnFilter 		= document.querySelectorAll('[hideonfilter]');

					clearTimeout(searchTimer);
					searchTimer = setTimeout(function() {window.app.loadPosts.loadPostsSplit('filter-change', filters, articlesInitial, articlesAdditional, hideOnFilter)}, 500);
				} else {
					let loadMoreFilters 			= ajaxParent.querySelector('.filter-form');
					let loadMoreButton 				= ajaxParent.querySelector('.btn--load-more');
					let loadMoreButtonWrapper 		= ajaxParent.querySelector('.load-more-button');
					let loadMoreContainer			= ajaxParent.querySelector('.load-more-container');
					let paginationContainer			= ajaxParent.querySelector('.pagination-container');

					clearTimeout(searchTimer);
					searchTimer = setTimeout(function() {window.app.loadPosts.loadPosts('filter-change', ajaxParent, loadMoreButton, loadMoreFilters, loadMoreContainer, paginationContainer, loadMoreButtonWrapper)}, 250);
				}
			});
		})
	}
}